export default __webpack_public_path__ + "static/media/way2.6beef2f2.gif";